// kyc update
import React, { useState, useEffect, useRef } from "react";
import { View, Image,  Text, TouchableOpacity, Dimensions, ScrollView, FlatList} from "react-native";
import { getAllVehiclesList, filterVehicle, sendOtp, validateOtpWithToken } from "./../../api/apiManager";
import { getOptIn } from "./../../api/maxProApi";
import ModalAlert from "../../common/ModalAlert";
import CustomButton from "../../common/CustomButton";
import Countdown from "react-countdown";
import { get, isEmpty } from "lodash";
import Loader from "../../common/Loader";
import CText from "../../common/CText";
import { COLORS, FONTS } from "../../constant";
import * as RootNavigation from "../../utilities/RootNavigation";
import CView from "../../common/CView";
import CButton from "../../common/CButton";
import CImage from "../../common/CImage";
import QuickLinks from "../Profile/QuickLinks";
import CustomInput from "../../common/CustomInput";
import ModalAlertMultipleButtons from "../../common/ModalAlertMultipleButtons";
import useStyles from "./MPSelectVehicle_Styles";

const isSmallDevice = Dimensions.get("window").width < 767;
const isTabView = Dimensions.get("window").width > 767 && Dimensions.get("window").width < 1024;

export default function MPSelectVehicle(props) {
    const styles = useStyles();
    const otpPattern = /^\d{6}$/;
    const [loading, setLoading] = useState(false);
    const [vehicleList, setVehicleList] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [targetVrn, setTargetVrn] = useState("");
    const [isTagCloseModalEnable, setTagCloseModalEnable] = useState("");
    const [alertModalVisible, setAlertModalVisible] = useState(false);
    const [otpModalVisible, setOtpModalVisible] = useState(false);
    const [otpData, setOtpData] = useState("");
    const [otp, setOtp] = useState();
    const [otpNbr, setOtpNbr] = useState("");
    const [requestId, setRequestId] = useState("");
    const [otpMsg, setOtpMsg] = useState("");
    const [optInSuccess, setOptInSuccess] = useState(false);
    const [alertModal, setAlertModal] = useState({title: "", status: "", message: "", navigateScreen: "", actionButton: "", });
    const counterRef = useRef(null);
    const [timerState, setTimeState] = useState("");

    const onCloseModal = () => {
        setAlertModalVisible(false);
        if(optInSuccess == true){ RootNavigation.navigate("Home", { screen: "Home",}) }
    };

    useEffect(() => {
        if (otpModalVisible)
            setTimeState({
                times: [Date.now() + 5000, Date.now() + 12000, Date.now() + 17000, Date.now() + 22000,],
                currentTimeIndex: 0,
                currentTime: Date.now() + 60000,
            });
    }, [otpModalVisible]);
    const timerRenderer = ({ hours, minutes, seconds, completed, api }) => {
        if (completed || isNaN(minutes)) {
            return (
                <>
                    <Text>{"00:00"}</Text>
                    <TouchableOpacity
                        onPress={() => {
                            setTimeState({
                                times: [ Date.now() + 5000, Date.now() + 12000, Date.now() + 17000, Date.now() + 22000, ],
                                currentTimeIndex: 0,
                                currentTime: Date.now() + 60000,
                            });
                            setTimeout(() => { api.start();}, 500);
                            let reqObj = { id: global.userCd, type: "tagClosure",};
                            getOtp(reqObj);
                        }}>
                        <CText.resendText>{"Resend Otp"}</CText.resendText>
                    </TouchableOpacity>
                </>
            );}
        return (
            <>
                <Text>  {minutes}:{seconds} </Text>
                <View><CText.resendText style={{ color: COLORS.gray }}>{"Resend Otp"} </CText.resendText> </View>
            </>
        );
    };
    const completeTime = () => {
        if ( timerState.times.length - 1 <= timerState.times.indexOf(timerState.currentTime) )
            return;
        // move to next time
        timerState.currentTimeIndex++;
        timerState.currentTime = new Date(timerState.times[timerState.currentTimeIndex + 1] );
    };

    useEffect(() => {getAllVehiclesListApi() }, []);

    const getAllVehiclesListApi = () => {
        setLoading(true);
        getAllVehiclesList()
            .then((res) => {
                if (res && !isEmpty(res)) {
                    let withoutMPVehData = []
                     withoutMPVehData = res.filter(item=>item.maxProStatus != "Enabled")
                    console.log('withoutMPVehData',withoutMPVehData)
                    setVehicleList(withoutMPVehData);
                    setLoading(false)
                }
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                console.log("<------------ error in tag details ----------->");
            }); };

    useEffect(() => {
        if (searchText && searchText.length > 2) { searchFilter(); } else if ((searchText && searchText.length < 2) || searchText == "") { getAllVehiclesListApi(); }
    }, [searchText]);

    const searchFilter = () => {
        setLoading(true);
        let req = { vrn_contains: searchText,  assignedVrnList: null,};
        filterVehicle(req)
            .then((res) => {
                setVehicleList(res || []);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                console.log("<------------ error in tag details ----------->");
            });
    };

    const vehicleSelelctionForCredit = (params) => { setTargetVrn(params.toVrn);};

    const getOtp = (item) => {
        console.log(props.selectedVrnData);
        var params = { id: global.userCd, type: "tagClosure",  };
        setLoading(true);
        sendOtp(params)
            .then((response) => {
                let res = response?.data;
                if (res.statusCode == 1003 || res.statusCode == 200) {
                    setLoading(false);
                    setRequestId(res?.response);
                    setOtpMsg(res.message);
                    setOtpData(res);
                    setOtpModalVisible(true);
                } else if ( res.statusCode == -1052 || res.statusCode == 500 || res.statusCode == -1017 || res.statusCode == -1003 || res.statusCode == -1004 || res.statusCode == -1100) {
                    setAlertModal({ title: "Error", status: "error", message: res.message, navigateScreen: "", actionButton: "OK", });
                    setAlertModalVisible(true);
                    setLoading(false);
                    setOtpModalVisible(true);
                }
            })
            .catch((err) => {
                setAlertModal({ title: "Error", status: "error",  message: err.message, navigateScreen: "", actionButton: "OK", });
                setAlertModalVisible(true);
                setLoading(false)
            });
    };

    const onClickValidateOtp = () => {
        let reqObj = {requestId: requestId?.otp, otp: otp, type: "tagClosure", };
        setLoading(true);
        validateOtpWithToken(reqObj)
            .then((res) => {
                setOtp("");
                if ( res.statusCode == 200 ||  res.statusCode == 1020 || res.statusCode == 1034 || res.statusCode == 1053 || res.statusCode == 1008) {
                    setLoading(false);
                    setOtpModalVisible(false);
                    setOtpNbr("");
                    setAlertModal({ title: "Successful", status: "success",  message: res.message, navigateScreen: "", actionButton: "OK",});
                    setAlertModalVisible(true);
                    props.setScreen('TagClosure')
                } else if (res.statusCode == -1020 || res.statusCode == 500 || res.statusCode == -1008 ||  res.statusCode == -1053 || res.statusCode == -1017 || res.statusCode < 0 ) {
                    setOtpModalVisible(false);
                    setAlertModal({ title: "Error", status: "error",  message: res.message, navigateScreen: "", actionButton: "OK",});
                    setAlertModalVisible(true);
                    setLoading(false);
                    setOtpNbr("");
                } else {
                    setOtpModalVisible(false);
                    setAlertModal({ title: "Error", status: "error",  message: res.message, navigateScreen: "", actionButton: "OK",});
                    setAlertModalVisible(true);
                    setLoading(false);
                    setOtpNbr("");
                }
            })
            .catch((err) => {
                setOtpModalVisible(false);
                setAlertModal({ title: "Error",  status: "error", message: err.message, navigateScreen: "", actionButton: "OK",});
                setAlertModalVisible(true);
                setLoading(false);
                setOtpNbr("");
            });
    };

    const onClickMPOptIn = () => {
        setLoading(true)
        let param = { customerId: "", vrn: targetVrn?.vrn ? targetVrn?.vrn : "", requestType: "OPT-IN", tagId:targetVrn?.fastagId ? targetVrn?.fastagId : ""}
        console.log(param, 'MP opt In req obj in select Vehicle')
        getOptIn(param).then(res => {
            setLoading(false)
            if (res?.statusCode == 200 || res?.statusCode == 1102) {
                 setAlertModal({  title: "Successful", status: "success",  message: res.message, navigateScreen: "",  actionButton: "OK",});
                setAlertModalVisible(true);
                setOptInSuccess(true)
            } else if (res?.statusCode < 0 || res?.statusCode == 500 ||res?.statusCode == -1102) {
                setAlertModal({  title: "Error",status: "error", message: res.message, navigateScreen: "", actionButton: "OK", });
                setAlertModalVisible(true);
                setLoading(false)
            }
        }).catch(err => {
            setAlertModal({  title: "Error",status: "error", message: err.message, navigateScreen: "", actionButton: "OK", });
            setAlertModalVisible(true);
            setLoading(false)
        })
    }

    return (
        <>
            <View style={styles.container}>
                <View style={styles.navWidget}>
                    <View style={styles.navWidgetInner}>
                        <View style={{ flexDirection: "row", }}>
                            <TouchableOpacity onPress={() => { RootNavigation.navigate("Home", { screen: "Home" })}} title={"FASTag MAX "} >
                                <CImage.backIcon /> 
                            </TouchableOpacity>
                            <CText.tripBenifitText style={{ marginLeft: 10 }}>  {"FASTag MAX "} </CText.tripBenifitText>
                        </View>
                        <CText.mpHeaderDesc >{"Please select a Tag that you want to upgrade to MAX"}</CText.mpHeaderDesc>
                    </View>
                    <View style={styles.proceedBtnDT}>  
                        <CButton isDisabled={targetVrn == ""} onPress={() => { onClickMPOptIn() }} title={"Proceed"} /> 
                     </View>
                </View>

                <View style={styles.contentWidget}>
                    {searchText == "" && vehicleList.length === 0 ? null : (
                        <View style={styles.searchWidget}>
                            <TouchableOpacity style={styles.searchIconContainerStyle}>  
                                <CImage.IconSearch></CImage.IconSearch> 
                            </TouchableOpacity>
                            <CustomInput 
                                label={" Search "} 
                                onValueChanged={(t) => { setSearchText(t);}} 
                                value={searchText}  
                                placeholder={"Vehicle Reg No."} 
                                style={{ height: 33,marginTop:10,marginLeft:10, }}  
                            />
                            
                        </View>
                    )}

                    <ScrollView showsHorizontalScrollIndicator={false} horizontal={true} style={[styles.scrollViewStyle]}>
                        <FlatList
                            extraData
                            style={styles.flatListStyle}
                            data={isEmpty(vehicleList) ? [] : vehicleList}
                            key={vehicleList.length}
                            renderItem={({ item }) => {
                                return (
                                    <View style={styles.viewStyle}>
                                        <CImage.CarImg></CImage.CarImg>
                                        <CView style={{ flex: 3, marginRight: 10, marginLeft: 10 }}>
                                            <View style={[styles.vehicleViewStyle, { flex: 4 }]}>
                                                <CText.vrnText> {get(item, "vrn", "")}</CText.vrnText>
                                                <CText.vehicleModal> {get(item, "fastagId", "")}</CText.vehicleModal>
                                                <View>
                                                    {item.status && item.status != "Activated" && (
                                                        <View style={{flexDirection: "row", alignItems: "center" }}>
                                                            <Image source={item.status == "Hotlisted by service provider"  || item.status == "Closed by NPCI" ? require("../../assets/images/hotlisted_icon.png") : item.status == "Low Balance" ? require("../../assets/images/lowbalance_icon.png") : item.status == "Blacklist" ? require("../../assets/images/blacklisted_icon.png") : null} style={{ height: 16, width: 16, top: 0 }} />
                                                            <Text style={[styles.lowBalanceText, { color: item.status == "Hotlisted by service provider" || item.status == "Closed by NPCI" ? "#e9730d" : item.status == "Low Balance" ? "#ff0000" : item.status == "Blacklist" ? "#880000" : "#e9730d" }]}>
                                                                {item.status == "Hotlisted by service provider" ? "Hotlisted" : item.status == "Closed by NPCI" ? "Closed by NPCI" : item.status == "Low Balance" ? "Low Balance" : item.status == "Blacklist" ? "Blacklisted" : item.status}
                                                            </Text>
                                                        </View>
                                                    )}
                                                </View>
                                            </View>
                                            <CView FR AC MT={5}>
                                                <CImage.IconToll></CImage.IconToll>
                                                <CView style={{ marginLeft: 20 }}>
                                                    <CText.priceText>{"\u20B9  "} {get(item, "fastagBalance", "").toFixed(2)} </CText.priceText>
                                                    <CText.vehicleModal>{"FASTag Balance"}</CText.vehicleModal>
                                                </CView>
                                            </CView>
                                        </CView>
                                        <TouchableOpacity  onPress={() => { vehicleSelelctionForCredit({ toVrn: item });}} style={styles.radiobuttonOutSideStyle}>
                                            {targetVrn?.vrn == item.vrn ? (  <CImage.TickActive></CImage.TickActive> ) : null}
                                        </TouchableOpacity>
                                    </View>
                                );
                            }}
                            keyExtractor = {(item, index) => index+"_"+item?.id?.toString() }
                            numColumns={isSmallDevice ? null : isTabView ? 2 : 3}
                        />
                    </ScrollView>
                    <View style={styles.proceedBtnMobile}>
                         <CButton isDisabled={targetVrn == ""} onPress={() => {onClickMPOptIn()}} title={"Proceed"} /> 
                    </View>
                </View>
                <View style={{ marginTop: -30, marginBottom: 30 }}> 
                    <QuickLinks navigation={props.navigation} /> 
                </View>
            </View>

            {alertModalVisible ? (
                <View style={styles.overlayViewStyle}>
                    <ModalAlert title={alertModal.title} status={alertModal.status} message={alertModal.message} navigateScreen={alertModal.navigateScreen} actionButton={"OK"} onCloseModal={onCloseModal} />
                </View>
            ) : null}
            {isTagCloseModalEnable ? (
                <View style={styles.overlayViewStyle}>
                    <ModalAlertMultipleButtons
                        title={"Tag Closure Charges"}
                        status={"No Status"}
                        bullet={"."}
                        bulletMessage={"As per IDFC First Bank’s policy, for any FASTag which has been active for less than 60 days calculated from the Tag Issuance Date, a Tag Closure Charge of ₹ 200 will be applicable. Please click on Yes, I agree to proceed with Tag Closure"}
                        checkbox={true}
                        cancelButton={"Cancel"}
                        proceedButton={"Proceed to close tag"}
                        onPressActionButton1={() => {  setTagCloseModalEnable(false); }}
                        onPressActionButton2={() => {
                            getOtp()
                            setTagCloseModalEnable(false);
                        }}
                        backgroundColor={"#bd2d37"}
                        color={"#ffffff"}
                    />
                </View>
            ) : null}
            {otpModalVisible ? (
                <View style={styles.overlayViewStyle}>
                    <View style={styles.overlayContainer}>
                        <View style={styles.overlay}>
                            <View style={styles.overlayContentViewStyle}>
                                <CText.enterOtpText>{"Enter OTP"}</CText.enterOtpText>
                                <CText.otpDescText> {otpMsg ? otpMsg : ''} </CText.otpDescText>
                                <View style={{ alignSelf: "center" }}>
                                    <CustomInput
                                        onValueChanged={(e) => setOtp(e)}
                                        value={otp}
                                        keyboardType="numeric"
                                        pattern={/^\d{6}$/}
                                        errorMessage={"Enter Valid OTP"}
                                        maxLength={6}
                                        style={[styles.otpInputViewStyle, { alignSelf: "center" }]}
                                    />
                                </View>
                                <View style={styles.resendViewStyle}>
                                    <Countdown
                                        ref={counterRef}
                                        date={timerState.currentTime}
                                        key={timerState.currentTimeIndex}
                                        onComplete={completeTime}
                                        intervalDelay={0}
                                        precision={3}
                                        renderer={timerRenderer}
                                    />
                                </View>
                                <View style={styles.footerBtnWrapper}>
                                    <CustomButton
                                        text={"Submit"}
                                        onPress={() => {
                                            !otpPattern.test(otp) ? "" : onClickValidateOtp();
                                            props.setData({ ...props.data, ...{ selectedVehicle: targetVrn, vehicleLength: vehicleList?.length } })
                                        }}
                                        disable={!otpPattern.test(otp) ? true : false}
                                    />
                                </View>
                            </View>
                        </View>
                    </View>
                </View>
            ) : null}
            {loading && <Loader />}
        </>
    );
}

